// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IPV_MainContainer__BaeBN {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: clamp(20px, 5vw, 50px);
    box-sizing: border-box;
    min-height: 100vh;
    background: linear-gradient(to bottom right, #fff5f5, #fff);
}

.IPV_MainWrapper__Oc1n3 {
    border: 1px solid #ffaeae;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);
    width: 90%;
    max-width: 800px;
    height: 100%;
    margin: 0 auto;
    transition: all 0.3s ease;
}

.IPV_topPhotoDiv__RkJAG {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    padding: 12px;
}

.IPV_topPhotoContainer__GgOWo{
    display: flex;
    align-items: center;
    gap: 10px;
}
.IPV_topCameraText__Jn4aQ {
    font-size: clamp(16px, 2.5vw, 20px);
    font-weight: 500;
    line-height: 1.4;
    color: #363636;
    margin: 0;
}
.IPV_shieldHeading__iZzQx{
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: #636262;
}

.IPV_topClockDiv__aP-yW {
    display: flex;
    gap: 5px;
    margin-top: 7px;
}

.IPV_clockIcon__Az03l {
    height: 20px;
    width: 20px;
    align-self: center;
}

.IPV_clockText__WdW2s {
    font-size: 14px;
    color: #817E7E;
}

.IPV_shieldDiv__-kNVu {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    justify-content: center;
    margin-top: 20px;
}

.IPV_shieldText__mDrEi {
    font-size: 12px;
    align-items: center ;
}

.IPV_imageDiv__SlxV7 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0 15px;
}
.IPV_ImageContainer__mhkiy{
    display: flex;
    position: relative;
    flex-direction: column;

}
.IPV_Image1__NpPcp {
    height: clamp(150px, 30vw, 200px);
    width: auto;
    object-fit: contain;
}
.IPV_Image__7vAh1 {
    height: clamp(150px, 30vw, 200px);
    width: auto;
    object-fit: contain;
    margin-left: 0;
}
.IPV_logo__x70cu{
    height: 20px;
    position: absolute;
    bottom: 0%;
    right: 0%;
    transform: translate(25% ,25%);
}
.IPV_Ins__ncXXA{
    margin-left: 10px;
    align-self: center;
}
.IPV_Ins1__Rtw21{
    align-self: center;
}
.IPV_Incorrect__beq1a{
    color: #e38080;
    text-align: center;
    margin-top: 10px;
}
.IPV_Correct__gqveL{
    color:#69af2e;
    text-align: center;
    margin-top: 10px;
}
.IPV_kycInfo__mxfXj {
    display: flex;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
}

.IPV_Parra1__uDKc8, .IPV_Parra__g-o-O {
    text-align: center;
    color: #817E7E;
    font-size: 14px;
    margin-bottom: 5px;
    margin-top: 8px;
    line-height: 1.5;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}
.IPV_Info__RQuTG {
    color: #817E7E;
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    margin: 10px 0;
}

.IPV_InfoImg__KuXyo {
    margin-right: 12px;
    display: inline-flex;
    align-items: center;
}
.IPV_Instruction__5JdMN {
    margin-top: 25px;
    color: #817E7E;
    font-weight: 600;
    text-align: center;
    font-size: 15px;
    line-height: 1.6;
    padding: 0 20px;
}

.IPV_Line__gxlBy {
    border-bottom: 1px solid #e4e4e4;
    margin-top: 50px;
}

.IPV_verifyButton__uxWsQ {
    background-image: linear-gradient(to top, #f73439, #f8777b) !important;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    color: #fff;
    border-radius: 8px !important;
    border: none;
    cursor: pointer;
    padding: 8px 30px;
    margin: 10px auto;
    margin-left: 50%;
    transform: translate(-50%);
}

.IPV_verifyButton__uxWsQ.IPV_loading__6iY6q {
    opacity: 0.7;
    cursor: not-allowed;
}

.IPV_verifyButton__uxWsQ:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* ─── OR Divider ──────────────────────────────────────────────────────────── */
.IPV_orDivider__M234q {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 16px 24px 12px;
}
.IPV_orLine__YkkVd {
    flex: 1 1;
    height: 1px;
    background: #e4e4e4;
}
.IPV_orText__f0qmO {
    font-size: 13px;
    color: #aaa;
    white-space: nowrap;
}

/* ─── Email Button ────────────────────────────────────────────────────────── */
.IPV_emailButton__j2hxO {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: calc(100% - 48px);
    margin: 0 24px 20px;
    padding: 12px 20px;
    border: 2px solid #f86a6e;
    background: white;
    color: #f73439;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, transform 0.1s;
}
.IPV_emailButton__j2hxO:hover:not(:disabled) {
    background: #fff0f0;
    transform: translateY(-1px);
}
.IPV_emailButton__j2hxO.IPV_loading__6iY6q,
.IPV_emailButton__j2hxO:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
.IPV_btnSpinner__bUMHD {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid #fcd4d5;
    border-top-color: #f73439;
    border-radius: 50%;
    animation: IPV_spin__RuWtT 0.7s linear infinite;
}
@keyframes IPV_spin__RuWtT {
    to { transform: rotate(360deg); }
}

/* ─── Email Sent Confirmation Box ─────────────────────────────────────────── */
.IPV_emailSentBox__a0Vic {
    margin: 0 24px 20px;
    padding: 18px 16px;
    background: #fff8f8;
    border: 1.5px solid #ffd6d7;
    border-radius: 12px;
    text-align: center;
}
.IPV_emailSentIcon__xMw8g {
    font-size: 32px;
    margin-bottom: 6px;
}
.IPV_emailSentTitle__B2BX8 {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin-bottom: 6px;
}
.IPV_emailSentDesc__vBaD4 {
    font-size: 13px;
    color: #777;
    line-height: 1.6;
    margin-bottom: 14px;
}
.IPV_pollingIndicator__xRsG1 {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #f86a6e;
    font-weight: 500;
}
.IPV_pulseDot__8tDqq {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #f86a6e;
    animation: IPV_pulse__3eCrL 1.4s ease-in-out infinite;
    flex-shrink: 0;
}
@keyframes IPV_pulse__3eCrL {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.5); opacity: 0.5; }
}
.IPV_pollCounter__iNo0i {
    font-weight: 400;
    color: #aaa;
}

/* ─── Completion Overlay ──────────────────────────────────────────────────── */
.IPV_completeOverlay__xh0Lz {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: IPV_fadeIn__qzQMY 0.3s ease;
}
@keyframes IPV_fadeIn__qzQMY {
    from { opacity: 0; }
    to { opacity: 1; }
}
.IPV_completeCard__tnfnF {
    background: white;
    border-radius: 20px;
    padding: 40px 32px 32px;
    max-width: 360px;
    width: 90%;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
    animation: IPV_slideUp__316mN 0.4s cubic-bezier(0.34,1.56,0.64,1);
}
@keyframes IPV_slideUp__316mN {
    from { transform: translateY(40px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}
.IPV_completeRing__7MGON {
    width: 90px;
    height: 90px;
    margin: 0 auto 20px;
}
.IPV_completeSvg__gjORf {
    width: 100%;
    height: 100%;
}
.IPV_completeCircle__XaHu1 {
    stroke-dasharray: 226;
    stroke-dashoffset: 226;
    animation: IPV_drawCircle__41lX6 0.7s ease forwards;
}
@keyframes IPV_drawCircle__41lX6 {
    to { stroke-dashoffset: 0; }
}
.IPV_completeTick__PRKnU {
    stroke-dasharray: 60;
    stroke-dashoffset: 60;
    animation: IPV_drawTick__ewbRs 0.4s ease 0.65s forwards;
}
@keyframes IPV_drawTick__ewbRs {
    to { stroke-dashoffset: 0; }
}
.IPV_completeTitle__ec9bp {
    font-size: 22px;
    font-weight: 700;
    color: #2d2d2d;
    margin: 0 0 10px;
}
.IPV_completeSubtitle__i8B0r {
    font-size: 14px;
    color: #888;
    line-height: 1.7;
    margin: 0 0 20px;
}
.IPV_completeProgress__mEZ0M {
    height: 4px;
    border-radius: 2px;
    background: #ffd6d7;
    position: relative;
    overflow: hidden;
}
.IPV_completeProgress__mEZ0M::after {
    content: '';
    position: absolute;
    inset: 0;
    background: #f73439;
    animation: IPV_progressBar__JY1nO 3.5s linear forwards;
    transform-origin: left;
}
@keyframes IPV_progressBar__JY1nO {
    from { transform: scaleX(0); }
    to { transform: scaleX(1); }
}`, "",{"version":3,"sources":["webpack://./src/components/organism/IPV.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,+BAA+B;IAC/B,sBAAsB;IACtB,iBAAiB;IACjB,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,gDAAgD;IAChD,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,eAAe;AACnB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;;AAE1B;AACA;IACI,iCAAiC;IACjC,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sEAAsE;IACtE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,uDAAuD;AAC3D;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,+CAAoC;AACxC;AACA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,gFAAgF;AAChF;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,qDAA0C;IAC1C,cAAc;AAClB;AACA;IACI,WAAW,mBAAmB,EAAE,UAAU,EAAE;IAC5C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC/C;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,gFAAgF;AAChF;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sCAA2B;AAC/B;AACA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,uCAAuC;IACvC,iEAAsD;AAC1D;AACA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC/C;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mDAAwC;AAC5C;AACA;IACI,KAAK,oBAAoB,EAAE;AAC/B;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,uDAA4C;AAChD;AACA;IACI,KAAK,oBAAoB,EAAE;AAC/B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,sDAA2C;IAC3C,sBAAsB;AAC1B;AACA;IACI,OAAO,oBAAoB,EAAE;IAC7B,KAAK,oBAAoB,EAAE;AAC/B","sourcesContent":[".MainContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: clamp(20px, 5vw, 50px);\n    box-sizing: border-box;\n    min-height: 100vh;\n    background: linear-gradient(to bottom right, #fff5f5, #fff);\n}\n\n.MainWrapper {\n    border: 1px solid #ffaeae;\n    border-radius: 20px;\n    background-color: #fff;\n    box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);\n    width: 90%;\n    max-width: 800px;\n    height: 100%;\n    margin: 0 auto;\n    transition: all 0.3s ease;\n}\n\n.topPhotoDiv {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #e4e4e4;\n    padding: 12px;\n}\n\n.topPhotoContainer{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.topCameraText {\n    font-size: clamp(16px, 2.5vw, 20px);\n    font-weight: 500;\n    line-height: 1.4;\n    color: #363636;\n    margin: 0;\n}\n.shieldHeading{\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 28px;\n    color: #636262;\n}\n\n.topClockDiv {\n    display: flex;\n    gap: 5px;\n    margin-top: 7px;\n}\n\n.clockIcon {\n    height: 20px;\n    width: 20px;\n    align-self: center;\n}\n\n.clockText {\n    font-size: 14px;\n    color: #817E7E;\n}\n\n.shieldDiv {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin: 0 auto;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.shieldText {\n    font-size: 12px;\n    align-items: center ;\n}\n\n.imageDiv {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    flex-wrap: wrap;\n    gap: 20px;\n    padding: 0 15px;\n}\n.ImageContainer{\n    display: flex;\n    position: relative;\n    flex-direction: column;\n\n}\n.Image1 {\n    height: clamp(150px, 30vw, 200px);\n    width: auto;\n    object-fit: contain;\n}\n.Image {\n    height: clamp(150px, 30vw, 200px);\n    width: auto;\n    object-fit: contain;\n    margin-left: 0;\n}\n.logo{\n    height: 20px;\n    position: absolute;\n    bottom: 0%;\n    right: 0%;\n    transform: translate(25% ,25%);\n}\n.Ins{\n    margin-left: 10px;\n    align-self: center;\n}\n.Ins1{\n    align-self: center;\n}\n.Incorrect{\n    color: #e38080;\n    text-align: center;\n    margin-top: 10px;\n}\n.Correct{\n    color:#69af2e;\n    text-align: center;\n    margin-top: 10px;\n}\n.kycInfo {\n    display: flex;\n    margin-top: 20px;\n    justify-content: center;\n    align-items: center;\n    padding: 0 20px;\n}\n\n.Parra1, .Parra {\n    text-align: center;\n    color: #817E7E;\n    font-size: 14px;\n    margin-bottom: 5px;\n    margin-top: 8px;\n    line-height: 1.5;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.Info {\n    color: #817E7E;\n    text-align: center;\n    font-size: 14px;\n    line-height: 1.5;\n    margin: 10px 0;\n}\n\n.InfoImg {\n    margin-right: 12px;\n    display: inline-flex;\n    align-items: center;\n}\n.Instruction {\n    margin-top: 25px;\n    color: #817E7E;\n    font-weight: 600;\n    text-align: center;\n    font-size: 15px;\n    line-height: 1.6;\n    padding: 0 20px;\n}\n\n.Line {\n    border-bottom: 1px solid #e4e4e4;\n    margin-top: 50px;\n}\n\n.verifyButton {\n    background-image: linear-gradient(to top, #f73439, #f8777b) !important;\n    font-size: 16px;\n    font-weight: 400;\n    font-stretch: normal;\n    color: #fff;\n    border-radius: 8px !important;\n    border: none;\n    cursor: pointer;\n    padding: 8px 30px;\n    margin: 10px auto;\n    margin-left: 50%;\n    transform: translate(-50%);\n}\n\n.verifyButton.loading {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.verifyButton:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* ─── OR Divider ──────────────────────────────────────────────────────────── */\n.orDivider {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 16px 24px 12px;\n}\n.orLine {\n    flex: 1;\n    height: 1px;\n    background: #e4e4e4;\n}\n.orText {\n    font-size: 13px;\n    color: #aaa;\n    white-space: nowrap;\n}\n\n/* ─── Email Button ────────────────────────────────────────────────────────── */\n.emailButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: calc(100% - 48px);\n    margin: 0 24px 20px;\n    padding: 12px 20px;\n    border: 2px solid #f86a6e;\n    background: white;\n    color: #f73439;\n    font-size: 15px;\n    font-weight: 600;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.2s, color 0.2s, transform 0.1s;\n}\n.emailButton:hover:not(:disabled) {\n    background: #fff0f0;\n    transform: translateY(-1px);\n}\n.emailButton.loading,\n.emailButton:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n.btnSpinner {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border: 2px solid #fcd4d5;\n    border-top-color: #f73439;\n    border-radius: 50%;\n    animation: spin 0.7s linear infinite;\n}\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ─── Email Sent Confirmation Box ─────────────────────────────────────────── */\n.emailSentBox {\n    margin: 0 24px 20px;\n    padding: 18px 16px;\n    background: #fff8f8;\n    border: 1.5px solid #ffd6d7;\n    border-radius: 12px;\n    text-align: center;\n}\n.emailSentIcon {\n    font-size: 32px;\n    margin-bottom: 6px;\n}\n.emailSentTitle {\n    font-size: 16px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 6px;\n}\n.emailSentDesc {\n    font-size: 13px;\n    color: #777;\n    line-height: 1.6;\n    margin-bottom: 14px;\n}\n.pollingIndicator {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #f86a6e;\n    font-weight: 500;\n}\n.pulseDot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #f86a6e;\n    animation: pulse 1.4s ease-in-out infinite;\n    flex-shrink: 0;\n}\n@keyframes pulse {\n    0%, 100% { transform: scale(1); opacity: 1; }\n    50% { transform: scale(1.5); opacity: 0.5; }\n}\n.pollCounter {\n    font-weight: 400;\n    color: #aaa;\n}\n\n/* ─── Completion Overlay ──────────────────────────────────────────────────── */\n.completeOverlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    animation: fadeIn 0.3s ease;\n}\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n.completeCard {\n    background: white;\n    border-radius: 20px;\n    padding: 40px 32px 32px;\n    max-width: 360px;\n    width: 90%;\n    text-align: center;\n    box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n    animation: slideUp 0.4s cubic-bezier(0.34,1.56,0.64,1);\n}\n@keyframes slideUp {\n    from { transform: translateY(40px); opacity: 0; }\n    to { transform: translateY(0); opacity: 1; }\n}\n.completeRing {\n    width: 90px;\n    height: 90px;\n    margin: 0 auto 20px;\n}\n.completeSvg {\n    width: 100%;\n    height: 100%;\n}\n.completeCircle {\n    stroke-dasharray: 226;\n    stroke-dashoffset: 226;\n    animation: drawCircle 0.7s ease forwards;\n}\n@keyframes drawCircle {\n    to { stroke-dashoffset: 0; }\n}\n.completeTick {\n    stroke-dasharray: 60;\n    stroke-dashoffset: 60;\n    animation: drawTick 0.4s ease 0.65s forwards;\n}\n@keyframes drawTick {\n    to { stroke-dashoffset: 0; }\n}\n.completeTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #2d2d2d;\n    margin: 0 0 10px;\n}\n.completeSubtitle {\n    font-size: 14px;\n    color: #888;\n    line-height: 1.7;\n    margin: 0 0 20px;\n}\n.completeProgress {\n    height: 4px;\n    border-radius: 2px;\n    background: #ffd6d7;\n    position: relative;\n    overflow: hidden;\n}\n.completeProgress::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: #f73439;\n    animation: progressBar 3.5s linear forwards;\n    transform-origin: left;\n}\n@keyframes progressBar {\n    from { transform: scaleX(0); }\n    to { transform: scaleX(1); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `IPV_MainContainer__BaeBN`,
	"MainWrapper": `IPV_MainWrapper__Oc1n3`,
	"topPhotoDiv": `IPV_topPhotoDiv__RkJAG`,
	"topPhotoContainer": `IPV_topPhotoContainer__GgOWo`,
	"topCameraText": `IPV_topCameraText__Jn4aQ`,
	"shieldHeading": `IPV_shieldHeading__iZzQx`,
	"topClockDiv": `IPV_topClockDiv__aP-yW`,
	"clockIcon": `IPV_clockIcon__Az03l`,
	"clockText": `IPV_clockText__WdW2s`,
	"shieldDiv": `IPV_shieldDiv__-kNVu`,
	"shieldText": `IPV_shieldText__mDrEi`,
	"imageDiv": `IPV_imageDiv__SlxV7`,
	"ImageContainer": `IPV_ImageContainer__mhkiy`,
	"Image1": `IPV_Image1__NpPcp`,
	"Image": `IPV_Image__7vAh1`,
	"logo": `IPV_logo__x70cu`,
	"Ins": `IPV_Ins__ncXXA`,
	"Ins1": `IPV_Ins1__Rtw21`,
	"Incorrect": `IPV_Incorrect__beq1a`,
	"Correct": `IPV_Correct__gqveL`,
	"kycInfo": `IPV_kycInfo__mxfXj`,
	"Parra1": `IPV_Parra1__uDKc8`,
	"Parra": `IPV_Parra__g-o-O`,
	"Info": `IPV_Info__RQuTG`,
	"InfoImg": `IPV_InfoImg__KuXyo`,
	"Instruction": `IPV_Instruction__5JdMN`,
	"Line": `IPV_Line__gxlBy`,
	"verifyButton": `IPV_verifyButton__uxWsQ`,
	"loading": `IPV_loading__6iY6q`,
	"orDivider": `IPV_orDivider__M234q`,
	"orLine": `IPV_orLine__YkkVd`,
	"orText": `IPV_orText__f0qmO`,
	"emailButton": `IPV_emailButton__j2hxO`,
	"btnSpinner": `IPV_btnSpinner__bUMHD`,
	"spin": `IPV_spin__RuWtT`,
	"emailSentBox": `IPV_emailSentBox__a0Vic`,
	"emailSentIcon": `IPV_emailSentIcon__xMw8g`,
	"emailSentTitle": `IPV_emailSentTitle__B2BX8`,
	"emailSentDesc": `IPV_emailSentDesc__vBaD4`,
	"pollingIndicator": `IPV_pollingIndicator__xRsG1`,
	"pulseDot": `IPV_pulseDot__8tDqq`,
	"pulse": `IPV_pulse__3eCrL`,
	"pollCounter": `IPV_pollCounter__iNo0i`,
	"completeOverlay": `IPV_completeOverlay__xh0Lz`,
	"fadeIn": `IPV_fadeIn__qzQMY`,
	"completeCard": `IPV_completeCard__tnfnF`,
	"slideUp": `IPV_slideUp__316mN`,
	"completeRing": `IPV_completeRing__7MGON`,
	"completeSvg": `IPV_completeSvg__gjORf`,
	"completeCircle": `IPV_completeCircle__XaHu1`,
	"drawCircle": `IPV_drawCircle__41lX6`,
	"completeTick": `IPV_completeTick__PRKnU`,
	"drawTick": `IPV_drawTick__ewbRs`,
	"completeTitle": `IPV_completeTitle__ec9bp`,
	"completeSubtitle": `IPV_completeSubtitle__i8B0r`,
	"completeProgress": `IPV_completeProgress__mEZ0M`,
	"progressBar": `IPV_progressBar__JY1nO`
};
export default ___CSS_LOADER_EXPORT___;
